import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Header from "Components/Header";
import Footer from "Components/Footer";
import Card from "Components/Card";
import { fixoApi } from "Api";
import { Color } from "Styles/Theme";
import { device } from "Styles/Media";

const CorrectionList = () => {
  const [list, setList] = useState([]);
  useEffect(() => {
    getList();
    // eslint-disable-next-line
  }, []);

  const getList = async () => {
    try {
      const res = await fixoApi.correctionList();
      setList(res.data.statement);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container>
      <Header />
      <Content>
        <p>CORRECTION LIST</p>
        <h1>첨삭 리스트</h1>
        <Section>
          {list.length === 0 ? (
            <Notice>
              <p>
                첨삭 리스트가 비어있습니다. <br /> 서비스를 이용해 주세요.
              </p>
            </Notice>
          ) : (
            list.map((element) => <Card key={element.id} {...element} />)
          )}
        </Section>
      </Content>
      <Footer />
    </Container>
  );
};

export default CorrectionList;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 80px auto;
  padding: 0 25px;

  & > p {
    font-size: 18px;
    font-weight: bold;
    color: ${Color.purple};
  }
  & > h1 {
    font-size: 44px;
  }
`;

const Notice = styled.div`
  p {
    color: #e53e3e;
    font-size: 18px;
    background-color: rgba(255, 245, 245, 1);
    line-height: 1.5;
    padding: 20px 30px;
  }
`;

const Section = styled.section`
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 0.5fr));
  column-gap: 20px;
  row-gap: 40px;
  grid-auto-rows: 280px;
  @media ${device.tablet} {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;
